// import React from "react";

// const teamMembers = [
//   {
//     name: "Yusuf",
//     about: `Yusuf’s passion for the hospitality and food industry drew him to the creative space in the confectionary world, which inspired him to pursue a degree in Hotel Management and an MBA in Finance and Marketing. With over 14 years of culinary experience, Yusuf has worked his way up from a trainee to the director of culinary, gaining invaluable experience and expertise along the way.

// After spending a decade abroad, Yusuf returned to India and noticed that the quality of bakeries was not up to par. This realization inspired him to co-found Bakelore, where he had a blank slate to create a dynamic brand that would set a new standard in the industry.

// Yusuf is committed to using the best ingredients and techniques to create products that are both delicious and visually appealing. He is dedicated to ensuring continuous improvement so the brand remains at the forefront of the baking industry. In addition to his culinary expertise, Yusuf is also leveraging his Finance and Marketing skills to create effective strategies that help Bakelore stand out from the competition.`,
//   },
//   {
//     name: "Rahul",
//     about: `Rahul has a strong passion for entrepreneurship and is always looking for ways to innovate and improve the food industry. Prior to co-founding Bakelore, he worked for 8 years in various management roles, where he gained invaluable experience in operations, marketing, and customer service. In his role as the head of operations and marketing at Bakelore, Rahul plays a critical role in the day-to-day running of the business. He oversees everything from inventory management and production planning to marketing campaigns and social media strategies. Rahul inspires his team to work hard and take pride in their work, ensuring that the company delivers exceptional quality products and services to its customers.

// Under Rahul’s leadership, quality and customer satisfaction are integral for the brand to grow rapidly. Rahul is now dedicated to expanding to new locations by providing franchising opportunities for other passionate entrepreneurs. Rahul is dedicated to continuing the company’s success and is always looking for new ways to innovate and stay ahead of the competition.`,
//   },
// ];

// const OurTeam = () => {
//   return (
//     <section className="bg-[#f9f6f1] py-16 px-4 md:px-10 lg:px-20 text-gray-800">
//       <div className="text-center mb-10">
//         <p className="text-sm text-rose-400 tracking-wide uppercase mb-1">
//           Best Bakery in Hyderabad
//         </p>
//         <h2 className="text-3xl md:text-4xl font-semibold">Our Team</h2>
//       </div>

//       <div className="grid md:grid-cols-2 gap-10 max-w-7xl mx-auto">
//         {teamMembers.map((member, index) => (
//           <div
//             key={index}
//             className="bg-white shadow-sm border border-gray-100 rounded-xl p-8 hover:shadow-md transition-all duration-300"
//           >
//             <h3 className="text-xl font-medium mb-4">{member.name}</h3>
//             <div className="border border-gray-100 rounded-lg p-6 bg-[#fcfaf8]">
//               <h4 className="text-rose-400 font-medium mb-3">About</h4>
//               <p className="text-gray-600 leading-relaxed whitespace-pre-line text-sm">
//                 {member.about}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default OurTeam;


// import React from "react";

// const teamMembers = [
//   {
//     name: "Yusuf",
//     about: `Yusuf’s passion for the hospitality and food industry drew him to the creative space in the confectionary world, which inspired him to pursue a degree in Hotel Management and an MBA in Finance and Marketing. With over 14 years of culinary experience, Yusuf has worked his way up from a trainee to the director of culinary, gaining invaluable experience and expertise along the way.

// After spending a decade abroad, Yusuf returned to India and noticed that the quality of bakeries was not up to par. This realization inspired him to co-found Bakelore, where he had a blank slate to create a dynamic brand that would set a new standard in the industry.

// Yusuf is committed to using the best ingredients and techniques to create products that are both delicious and visually appealing. He is dedicated to ensuring continuous improvement so the brand remains at the forefront of the baking industry. In addition to his culinary expertise, Yusuf is also leveraging his Finance and Marketing skills to create effective strategies that help Bakelore stand out from the competition.`,
//   },
//   {
//     name: "Rahul",
//     about: `Rahul has a strong passion for entrepreneurship and is always looking for ways to innovate and improve the food industry. Prior to co-founding Bakelore, he worked for 8 years in various management roles, where he gained invaluable experience in operations, marketing, and customer service. In his role as the head of operations and marketing at Bakelore, Rahul plays a critical role in the day-to-day running of the business. He oversees everything from inventory management and production planning to marketing campaigns and social media strategies. Rahul inspires his team to work hard and take pride in their work, ensuring that the company delivers exceptional quality products and services to its customers.

// Under Rahul’s leadership, quality and customer satisfaction are integral for the brand to grow rapidly. Rahul is now dedicated to expanding to new locations by providing franchising opportunities for other passionate entrepreneurs. Rahul is dedicated to continuing the company’s success and is always looking for new ways to innovate and stay ahead of the competition.`,
//   },
// ];

// const OurTeam = () => {
//   return (
//     <section className="bg-[#f9f6f1] py-16 px-4 md:px-10 lg:px-20 text-gray-800 font-body">
//       <div className="text-center mb-12">
//         <p className="text-sm  tracking-wide uppercase mb-2 font-body">
//           Best Bakery in Hyderabad
//         </p>
//         <h2 className="text-3xl md:text-4xl font-heading text-gray-800 tracking-wide">
//           Our Team
//         </h2>
//       </div>

//       <div className="grid md:grid-cols-2 gap-10 max-w-7xl mx-auto">
//         {teamMembers.map((member, index) => (
//           <div
//             key={index}
//             className="bg-white shadow-sm border border-gray-100 rounded-xl p-8 hover:shadow-md transition-all duration-300"
//           >
//             {/* Team Member Name */}
//             <h3 className="text-2xl font-heading text-[#C08B89] mb-4 tracking-wide">
//               {member.name}
//             </h3>

//             {/* About Card */}
//             <div className="border border-gray-100 rounded-lg p-6 bg-[#fcfaf8]">
//               <h4 className=" font-medium mb-3 font-body uppercase tracking-wide">
//                 About
//               </h4>
//               <p className="text-gray-600 leading-relaxed whitespace-pre-line text-[15px]">
//                 {member.about}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default OurTeam;


import React from "react";

const teamMembers = [
//   {
//     name: "Yusuf",
//     image: "/images/yusuf.jpg",
//     about: `Yusuf’s passion for the hospitality and food industry drew him to the creative space in the confectionary world, which inspired him to pursue a degree in Hotel Management and an MBA in Finance and Marketing. With over 14 years of culinary experience, Yusuf has worked his way up from a trainee to the director of culinary, gaining invaluable experience and expertise along the way.

// After spending a decade abroad, Yusuf returned to India and noticed that the quality of bakeries was not up to par. This realization inspired him to co-found Bakelore, where he had a blank slate to create a dynamic brand that would set a new standard in the industry.

// Yusuf is committed to using the best ingredients and techniques to create products that are both delicious and visually appealing. He is dedicated to ensuring continuous improvement so the brand remains at the forefront of the baking industry. In addition to his culinary expertise, Yusuf is also leveraging his Finance and Marketing skills to create effective strategies that help Bakelore stand out from the competition.`,
//   },
  {
    name: "Appani Rahul",
    image: "https://bakelore.com/images/rahul-300x300-3.png",
    about: `Rahul has a strong passion for entrepreneurship and is always looking for ways to innovate and improve the food industry. Prior to co-founding Bakelore, he worked for 8 years in various management roles, where he gained invaluable experience in operations, marketing, and customer service. In his role as the head of operations and marketing at Bakelore, Rahul plays a critical role in the day-to-day running of the business. He oversees everything from inventory management and production planning to marketing campaigns and social media strategies. Rahul inspires his team to work hard and take pride in their work, ensuring that the company delivers exceptional quality products and services to its customers.

Under Rahul’s leadership, quality and customer satisfaction are integral for the brand to grow rapidly. Rahul is now dedicated to expanding to new locations by providing franchising opportunities for other passionate entrepreneurs. Rahul is dedicated to continuing the company’s success and is always looking for new ways to innovate and stay ahead of the competition.`,
  },
];

const OurTeam = () => {
  return (
    <section className="bg-[#f9f6f1] py-16 px-4 md:px-10 lg:px-20 text-gray-800">
      <div className="text-center mb-12">
        <p className="text-sm uppercase mb-2">
          Best Bakery in Hyderabad
        </p>
        <h2 className="text-3xl md:text-4xl font-bold">
          Our Founder
        </h2>
      </div>

      <div className="grid md:grid-cols-1 gap-10 max-w-7xl mx-auto">
        {teamMembers.map((member, index) => (
          <div
            key={index}
            className="bg-white rounded-xl p-8 shadow-sm border hover:shadow-md transition-all"
          >
            {/* Image */}
            <div className="flex justify-center mb-6">
              <img
                src={member.image}
                alt={member.name}
                className="w-32 h-32 md:w-40 md:h-40 rounded-full object-cover border-4 border-[#C08B89]"
              />
            </div>

            {/* Name */}
            <h3 className="text-2xl font-semibold text-[#C08B89] text-center mb-4">
              {member.name}
            </h3>

            {/* About */}
            <div className="bg-[#fcfaf8] border rounded-lg p-6">
              <h4 className="font-medium uppercase mb-3">
                {/* About */}
              </h4>
              <p className="text-gray-600 text-[15px] leading-relaxed whitespace-pre-line">
                {member.about}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurTeam;